// Keep the largest connected foreground region. Never fill holes or invent pixels.
export function cleanForeground(values: Float32Array, width: number, height: number) {
  const seen = new Uint8Array(values.length), queue = new Int32Array(values.length);
  let largest: number[] = [];
  for (let seed = 0; seed < values.length; seed++) {
    if (seen[seed] || values[seed] < 0.35) continue;
    let read = 0, size = 1; queue[0] = seed; seen[seed] = 1;
    while (read < size) {
      const i = queue[read++], x = i % width, y = Math.floor(i / width);
      for (let dy = -1; dy <= 1; dy++) for (let dx = -1; dx <= 1; dx++) {
        const nx = x + dx, ny = y + dy, n = ny * width + nx;
        if (nx >= 0 && nx < width && ny >= 0 && ny < height && !seen[n] && values[n] >= 0.35) { seen[n] = 1; queue[size++] = n; }
      }
    }
    if (size > largest.length) largest = Array.from(queue.subarray(0, size));
  }
  const keep = new Uint8Array(values.length);
  // Retain one pixel of soft edge around the retained component, not distant islands.
  for (const i of largest) { const x = i % width, y = Math.floor(i / width);
    for (let dy = -1; dy <= 1; dy++) for (let dx = -1; dx <= 1; dx++) {
      if (x + dx >= 0 && x + dx < width && y + dy >= 0 && y + dy < height) keep[(y + dy) * width + x + dx] = 1;
    }
  }
  return Float32Array.from(values, (v, i) => keep[i] ? v : 0);
}

export function sourcePoint(clientX: number, clientY: number, rect: { left: number; top: number; width: number; height: number }, transform: { x: number; y: number; scale: number }) {
  return { x: ((clientX - rect.left) * 1080 / rect.width - transform.x) / transform.scale,
    y: ((clientY - rect.top) * 1440 / rect.height - transform.y) / transform.scale };
}
